export default function useClientWindowApi() {
  //@ts-ignore
  window.api = {}

  //@ts-ignore
  return window.api
}
